import getDraftStatutesErrors from 'features/Onboarding/modules/CapitalDepositDraftStatutes/libs/getDraftStatutesErrors';
import getDraftStatutesStatus from 'features/Onboarding/modules/CapitalDepositDraftStatutes/libs/getDraftStatutesModuleStatus';

import { State } from '../../machine';
import model from '../../machine/model';
import locales from './locales';
import { GetVerificationStep, VerificationStatus } from './types';

const getDraftStatutesStep: GetVerificationStep = ({
  isMainApplicant,
  verificationData,
}) => {
  const { company } = verificationData.viewer;

  const status = getDraftStatutesStatus({
    isCapitalDeposit: company.isCapitalDeposit,
    isCompanyCreationSASU: company.isCompanyCreationSASU,
    isMainApplicant,
    kybDocuments: company.kybDocuments ?? [],
  });

  return {
    errors: getDraftStatutesErrors({
      kybDocuments: company.kybDocuments ?? [],
    }),
    id: State.DRAFT_STATUTES,
    metadata: {
      event: model.events.GO_DRAFT_STATUTES(),
      iconName: 'file',
      isHidden:
        status === VerificationStatus.Completed ||
        status === VerificationStatus.Validated,
      label: locales.draftStatutes,
    },
    status,
  };
};

export default getDraftStatutesStep;
